<template>
  <div v-loading="dataLoading" v-if="detailsData">
    <div class="detail-top">
      <div class="title-txt">{{$t('message.tableCommon.orderAmount')}}</div>
      <div class="amount-box">
        <span class="amount-txt">{{detailsData.txnAmount ? detailsData.txnAmount.amount : ''}}</span>
        <img
          v-if="detailsData.txnAmount && getCurrencyImage(detailsData.txnAmount.currency)"
          class="currency-icon" :src="require(`@/assets/images/currency/${detailsData.txnAmount.currency}.png`)"/>
        <span :class="['status', `status-${detailsData.txnStatus}`]">{{setTxnStatus(detailsData)}}</span>
      </div>
    </div>
    <details-component :details-condition="detailCondition">
      <template #auditReason>
        <div class="opinion-box">
          <el-input
            type="textarea"
            :rows="4" v-model="auditReason"
            :placeholder="$t('message.validator.input', { input: $t('message.tableCommon.auditOpinion')})"
          ></el-input>
          <div class="opinion-btn-box">
            <el-button type="primary" @click="handleAudit('1')">{{$t('message.status.auditSuccessAndRefund')}}</el-button>
            <el-button class="margin-left-20" @click="handleAudit('2')">{{$t('message.status.auditFail')}}</el-button>
          </div>
        </div>
      </template>
    </details-component>
  </div>
</template>
<script>

import DetailsComponent from '@/components/base-details/details.vue';
import { ShowWarningMessage, ShowSuccessMessage } from '@/components/modal/tips/message-tips';
import GlobalData from '@/utils/global/index';
import { getEnantiomericValue, initSelectedData, splicingAmountAndCurrency } from '@/utils/tools/constant';
import { getCurrencyImage } from '@/utils/tools/currency';
import { isNullForDisplay } from '@/utils/tools/utils';
import DisputeService from '@/views/transaction/api/dispute.service';
import TransitionService from '@/views/transaction/api/transaction-query.service';
import { RefundStatus } from '@/views/transaction/status/transaction';

export default {
  components: {
    DetailsComponent,
  },
  data() {
    return {
      dataLoading: true,
      getTransactionDetails: TransitionService.getTransactionDetails,
      postRefundAmount: TransitionService.postRefundAmount,
      getCurrencyImage,
      disputeId: '',
      originalTxnId: '',
      flag: 0,
      txnTypeList: [],
      txnStatusList: [],
      disputeReasonList: [],
      detailCondition: [],
      getEnantiomericValue,
      detailsData: {},
      auditReason: '',
    };
  },
  methods: {
    async initData() {
      this.disputeId = this.$route.query.disputeId;
      this.originalTxnId = this.$route.query.originalTxnId;
      this.flag = this.$route.query.flag;
      const dict = await GlobalData.getDictList(['TXN_TYPE', 'MERC_TXN_STATUS', 'DISPUTE_REASON']);
      this.txnTypeList = initSelectedData(dict.TXN_TYPE);
      this.txnStatusList = initSelectedData(dict.MERC_TXN_STATUS);
      this.disputeReasonList = initSelectedData(dict.DISPUTE_REASON);
      await this.initDetailsAll();
    },
    getAddressTemplate(allData, title, type) {
      let titleIcon = '';
      if (type === 'mail') {
        titleIcon = require('@/assets/images/transaction/icon_mailing_address.png');
      } else if (type === 'bill') {
        titleIcon = require('@/assets/images/transaction/icon_billing_address.png');
      }
      return {
        topTitle: title,
        type: 'default',
        titleIcon,
        listTemplate: [
          {
            titleBar: { title: 'message.transaction.name' },
            key: 'name',
            textFunc: (data) => `${isNullForDisplay(data.firstName)} ${isNullForDisplay(data.lastName)}`,
          },
          {
            titleBar: { title: 'message.tableCommon.email' },
            key: 'email',

          },
          {
            titleBar: { title: 'message.transaction.zipCode' },
            key: 'postalCode',
          },
          {
            titleBar: { title: 'message.transaction.phone' },
            key: 'phone',

          },
          {
            titleBar: { title: 'message.transaction.city' },
            key: 'city',

          },
          {
            titleBar: { title: 'message.transaction.province' },
            key: 'province',

          },
          {
            titleBar: { title: 'message.transaction.country' },
            key: 'country',

          },
          {
            titleBar: { title: 'message.transaction.address' },
            key: 'address',

          },
        ],
        data: allData,
      };
    },
    getTransactionTemplate(allData) {
      return {
        topTitle: 'message.transaction.info',
        type: 'default',
        titleIcon: require('@/assets/images/transaction/icon_transaction.png'),
        listTemplate: [
          {
            titleBar: { title: 'message.tableCommon.txnSerialNumber' },
            key: 'txnId',
          },
          {
            titleBar: { title: 'message.tableCommon.txnType' },
            key: 'txnType',
            textFunc: (data) => getEnantiomericValue(this.txnTypeList, data.txnType),
          },
          {
            titleBar: { title: 'message.tableCommon.txnStatus' },
            key: 'txnStatus',
            textFunc: (row) => this.setTxnStatus(row),
          },
          { // 订阅合同号
            titleBar: { title: 'message.subscription.contractNo' },
            key: 'contractId',
            type: 'click',
            func: (data) => {
              this.$router.push({ path: '/subscription/order/view', query: { contractId: data.contractId } });
            },
          },
          {
            titleBar: { title: 'message.tableCommon.orderAmount' },
            key: 'txnAmount',
            textFunc: (data) => splicingAmountAndCurrency(data.txnAmount && data.txnAmount.currency, data.txnAmount && data.txnAmount.amount),
          },
          {
            titleBar: { title: 'message.tableCommon.txnTime' },
            key: 'txnTime',
          },
          {
            titleBar: { title: 'message.tableCommon.merchantOrderNumber' },
            key: 'merchantTxnId',

          },
          {
            titleBar: { title: 'message.tableCommon.productType' },
            key: 'productType',

          },
          {
            titleBar: { title: 'message.tableCommon.subProductType' },
            key: 'subProductType',

          },
          {
            titleBar: { title: 'message.tableCommon.cardType' },
            key: 'cardBin',

          },
          {
            titleBar: { title: 'message.tableCommon.requestId' },
            key: 'requestId',

          },
          {
            titleBar: { title: 'message.tableCommon.cardBinCountry' },
            key: 'cardBinCountry',

          },
          {
            titleBar: { title: 'message.tableCommon.refundState' },
            key: 'refundStatus',
            isInternationalization: true,
            textFunc: (data) => getEnantiomericValue(RefundStatus, data.refundStatus),
          },
          {
            titleBar: { title: 'message.tableCommon.bankCardNo' },
            key: 'cardNumber',
          },
          {
            titleBar: { title: 'message.tableCommon.appId' },
            key: 'appId',
          },
          {
            titleBar: { title: 'message.tableCommon.website' },
            key: 'website',
          },
          {
            titleBar: { title: 'message.tableCommon.eci' },
            key: 'eci',
            type: 'add-tip',
            text: this.$t('message.transaction.eciHint'),
          },
          {
            isInternationalization: true,
            titleBar: { title: 'message.tableCommon.require3d' },
            key: 'require3d',
            textFunc: (data) => (data.require3d ? 'message.status.yes' : 'message.status.no'),
          },
          {
            titleBar: { title: 'message.tableCommon.products' },
            key: 'products',
          },
          {
            titleBar: { title: 'message.tableCommon.ip' },
            key: 'ip',

          },
          {
            titleBar: { title: 'message.tableCommon.arn' },
            key: 'arn',

          },
          {
            titleBar: { title: 'message.tableCommon.userAgent' },
            key: 'userAgent',
          },
        ],
        data: allData,
      };
    },
    getDisputeTemplate(allData) {
      return {
        topTitle: 'message.dispute.disputeInfo',
        type: 'default',
        titleIcon: require('@/assets/images/transaction/icon_dispute_info.png'),
        rowColumn: 1,
        listTemplate: [
          {
            titleBar: { title: 'message.common.reason' },
            key: 'disputeReason',
            textFunc: (data) => getEnantiomericValue(this.disputeReasonList, data.disputeReason),
          },
          {
            titleBar: { title: 'message.tableCommon.otherReason' },
            key: 'otherReason',
          },
        ],
        data: allData,
      };
    },
    getSupplementaryTemplate(allData) {
      return {
        topTitle: 'message.tableCommon.supplementary',
        type: 'default',
        titleIcon: require('@/assets/images/transaction/icon_info.png'),
        rowColumn: 1,
        listTemplate: [
          {
            titleBar: { title: 'message.tableCommon.supplementary' },
            key: 'disputeDescription',
          },
        ],
        data: allData,
      };
    },
    getAuditTemplate(allData) {
      return {
        topTitle: 'message.tableCommon.auditOpinion',
        type: 'default',
        titleIcon: require('@/assets/images/transaction/icon_info.png'),
        rowColumn: 1,
        listTemplate: [
          {
            titleBar: { title: 'message.tableCommon.auditOpinion' },
            key: 'auditReason',
          },
        ],
        data: allData,
      };
    },
    // 需要审核的模板
    getAuditingTemplate(allData) {
      return {
        topTitle: 'message.tableCommon.auditOpinion',
        type: 'default',
        titleIcon: require('@/assets/images/transaction/icon_info.png'),
        rowColumn: 1,
        listTemplate: [
          {
            titleBar: { title: 'message.tableCommon.auditOpinion' },
            key: 'auditReason',
            type: 'slot',
          },
        ],
        data: allData,
      };
    },
    async initDetailsAll() {
      this.dataLoading = true;
      try {
        this.detailCondition.length = 0;
        this.detailCondition.push(this.getTransactionTemplate({}));
        this.detailCondition.push(this.getAddressTemplate({}, 'message.transaction.mailingAddress', 'mail'));
        this.detailCondition.push(this.getAddressTemplate({}, 'message.transaction.billingAddress', 'bill'));
        this.detailCondition.push(this.getDisputeTemplate({}));
        this.detailCondition.push(this.getSupplementaryTemplate({}));
        this.detailCondition.push(this.getAuditTemplate({}));
        const disputeInfo = await DisputeService.queryDetail({ disputeId: this.disputeId });
        const txnInfo = await this.getTransactionDetails(this.originalTxnId);
        const data = {
          ...disputeInfo,
          ...txnInfo,
        };
        this.detailCondition.length = 0;
        this.detailsData = data;
        this.detailCondition.push(this.getTransactionTemplate(data));
        this.detailCondition.push(this.getAddressTemplate(data.shippingInformation, 'message.transaction.mailingAddress', 'mail'));
        this.detailCondition.push(this.getAddressTemplate(data.billingInformation, 'message.transaction.billingAddress', 'bill'));
        this.detailCondition.push(this.getDisputeTemplate(data));
        this.detailCondition.push(this.getSupplementaryTemplate(data));
        if (+data.auditStatus === 0 && +this.flag === 0) { // 待审核且是审核模式，查看模式不显示
          this.detailCondition.push(this.getAuditingTemplate(data));
        } else if (+data.auditStatus !== 0) { // 只要不是待审核时，都显示
          this.detailCondition.push(this.getAuditTemplate(data));
        }
      } catch (err) {
        //
      }
      this.dataLoading = false;
    },
    // 交易状态固定显示
    setTxnStatus(data) {
      if (data.txnType === '0029' && (data.txnStatus === 'P' || data.txnStatus === 'I')) {
        return 'message.status.acceptedSuccess';
      }
      return getEnantiomericValue(this.txnStatusList, data.txnStatus);
    },
    async handleAudit(status) {
      if (`${status}` === '2' && !this.auditReason) { // 审核不通过且审核意见未填时
        ShowWarningMessage(this.$t('message.validator.input', { input: this.$t('message.tableCommon.auditOpinion') }));
        return;
      }
      const data = {
        disputeId: this.disputeId,
        auditReason: this.auditReason,
        auditStatus: status,
      };
      this.dataLoading = true;
      try {
        await DisputeService.postAudit(data);
        // this.initDetailsAll();
        ShowSuccessMessage(this.$t('message.submitSuccessfulTip'));
        this.$router.go(-1);
      } catch (err) {
        //
      }
      this.dataLoading = false;
    },
  },
  mounted() {
    this.initData();
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';

.detail-top {
  margin-bottom: 30px;
  padding-top: 4px;
  .title-txt {
    font-size: 14px;
    font-family: Avenir-Book, Avenir;
    font-weight: normal;
    color: $color-text-primary;
    line-height: 19px;
  }

  .amount-box {
    display: flex;
    align-items: center;
    margin-top: 7px;
    margin-bottom: 15px;
    font-family: Avenir-Heavy, Avenir;
    color: $color-text-primary;
    font-weight: 800;
    .amount-txt {
      font-size: 30px;
      line-height: 41px;
      margin-right: 15px;
    }

    .currency-icon {
      width: 26px;
      margin-right: 38px;
    }

    .status {
      font-size: 14px;
      line-height: 30px;
      padding: 0 8px;
      height: 30px;
      border-radius: 4px;
      background: rgba(252,100,45,0.15);

      &-S {
        background: rgba(0,221,40,0.15);
      }

      &-P, &-U {
        background:rgba(255,178,9,0.15);
      }

      &-N {
        background:#F1F5F7;
      }
    }
  }
}
</style>

<style lang="scss">
.opinion-box {
  display: flex;
  flex-direction: column;
  width: 60%;

  .opinion-btn-box {
    margin-top: 20px;
  }
}
</style>
